<template>
  <div class="text-center mx-auto px-[10px] sm:px-5 md:px-10 w-full relative top-0 overflow-y-auto pb-[60px]">
    <div class="h-fit-content flex justify-start items-center flex-col gap-[30px] mt-[80px]">
      <a @click.prevent="resetPage" class="flex items-center router-link-active">
        <img src="/images/geeq-explore-14-14@2x.png" class="flex items-center m-auto router-link-active max-w-[500px] min-w-[300px]" />
      </a>
      <div class="mt-[70px]">
        <search-form ref="form" />
      </div>
    </div>
    <!-- <section class="stats-section pb-[100px] mt-[80px]">
      <div class="stats-header mb-[40px]">
        <h2 class="stats-title">Network Statistics</h2>
        <p class="stats-subtitle">Real-time data from the Geeq blockchain network</p>
      </div>
      
      <div class="stats-grid">
        <div class="stats-category">
          <h3 class="category-title">Network Overview</h3>
          <div class="cards-row">
            <InfoCard title="Active Chains" value="2" />
            <InfoCard title="Total Accounts" value="2,000" />
            <InfoCard title="Total Transactions" value="28.4B" />
          </div>
        </div>

        <div class="stats-category">
          <h3 class="category-title">Assets & Economy</h3>
          <div class="cards-row">
            <InfoCard title="Coins in Circulation" value="20M" />
            <InfoCard title="Assets Issued" value="686" />
            <InfoCard title="NFT Items Minted" value="1,400" />
          </div>
        </div>

        <div class="stats-category">
          <h3 class="category-title">Network Activity</h3>
          <div class="cards-row">
            <InfoCard title="Transaction Fees Earned" value="19.8M" />
            <InfoCard title="Latest Block" :value="formatDate('2025-04-16T04:56:51.596Z')" />
          </div>
        </div>
      </div>
    </section> -->
  </div>

</template>

<script>
import { defineComponent } from 'vue';
import { formatDate } from '@/helpers/date';

// import HeadingComponent from '@/components/web/HeadingComponent.vue';
import SearchForm from '@/components/web/SearchForm';
import InfoCard from '@/components/web/InfoCard.vue';

export default defineComponent({
  name: 'HomePage',
  components: { 
    SearchForm, 
    // InfoCard,
    // HeadingComponent
  },
  created() {
    // const data = {
    //   searchType: 'Metadata',
    //     search: '',
    //     searchStrType: 'meta',
    //     isExactMatch: false,
    // };
    // this.$store.commit('setSearchSettings', data)
    // this.$store.commit('resetSearchData')
  },
  methods: {
      formatDate(d) {
      return formatDate(d);
    },
    resetPage() {
      this.$refs.form.resetForm()
    }
  }
});
</script>

<style lang="scss" scoped>
.stats-section {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.stats-header {
  text-align: center;
  margin-bottom: 48px;
}

.stats-title {
  font-family: 'Jost', sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.stats-subtitle {
  font-family: 'Jost', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.stats-grid {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.stats-category {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #f3f4f6;
  border-radius: 16px;
  padding: 32px 24px;
  backdrop-filter: blur(10px);
  transition: all 0.2s ease;
}

.stats-category:hover {
  background: rgba(255, 255, 255, 0.8);
  border-color: #e5e7eb;
}

.category-title {
  font-family: 'Jost', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 24px 0;
  text-align: center;
  position: relative;
}

.category-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #0095C5, #60BCD0);
  border-radius: 1px;
}

.cards-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  justify-items: center;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .stats-title {
    font-size: 28px;
  }
  
  .stats-subtitle {
    font-size: 15px;
  }
  
  .stats-category {
    padding: 24px 20px;
  }
  
  .cards-row {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .stats-section {
    padding: 0 16px;
  }
  
  .stats-header {
    margin-bottom: 32px;
  }
  
  .stats-title {
    font-size: 24px;
  }
  
  .stats-subtitle {
    font-size: 14px;
  }
  
  .stats-grid {
    gap: 32px;
  }
  
  .stats-category {
    padding: 20px 16px;
  }
  
  .category-title {
    font-size: 16px;
    margin-bottom: 20px;
  }
  
  .cards-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .stats-title {
    font-size: 22px;
  }
  
  .stats-category {
    padding: 16px 12px;
  }
  
  .cards-row {
    gap: 12px;
  }
}
</style>
